import {Model} from "./Model";
import {IApiGameAccountType} from "../typings/apiResponse";

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.GameAccountType
 *
 * @requires apiResponse
 *
 * @description
 * The GameAccountType object represents a game account type on ESL Play.
 * Such object has a type, readOnly property and can have an idProvider or not.
 */
export class GameAccountType extends Model {

    constructor(private apiResponse: IApiGameAccountType) {
        super(apiResponse);
    }

    /**
     * Returns the game account type
     * @returns {string}
     *
     * Example:
     * "pb_guid_aa3" or "steamidcsgo"
     */
    public getType(): string {
        return this.apiResponse.type;
    }

    /**
     * Returns the game account idProvider matching the game account type if any
     * @returns {string|null}
     *
     * Example:
     * "psn" or null if none.
     * If none, that means the user can modify his game account.
     */
    public getIdProvider(): any {
        return this.apiResponse.idProvider;
    }

    /**
     * Returns the game account readOnly property of a game account
     * @returns {boolean}
     *
     * Example:
     * idProvider game accounts can have either readOnly false (user provides one value, we compute the other)
     * or true (user can not provide a value).
     */
    public getReadOnly(): boolean {
        return this.apiResponse.readOnly;
    }
}